export const GetStatusColor = ( status, customColorMap ) => {
  return customColorMap[status] || "text-gray-500";
};

export const GetDynamicColor = ( value, colorMap ) => {
  const range = colorMap.find(range => value >= range.min && value <= range.max);
  return range ? range.color : "text-gray-500"; // Color por defecto si no hay coincidencia
};

export const GetStatusClass = (estado) => {
  switch (estado) {
    case "Terminado con exito":
      return "bg-green-500";
    case "Por comenzar":
      return "bg-yellow-300";
    case "En proceso":
      return "bg-blue-500";
    case "Abandonado":
      return "bg-black";
    case "Congelado":
      return "bg-sky-300";
    default:
      return "bg-gray-500";
  }
};

export const PercetageColor = [
  { min: 0, max: 50, color: "text-red-500" },
  { min: 51, max: 80, color: "text-blue-500" },
  { min: 81, max: 100, color: "text-green-500" }
]

export const PlanBackgroundColor = {
  "Elite": "bg-green-500 rounded-md text-white",
  "Pro": "bg-blue-500 rounded-md text-white",
  "Premium": "bg-purple-500 rounded-md text-white"
}

export const ColorSiNo = {
  "No": "text-red-500",
  "Si": "text-green-500",
}

export const TextColorQuotesStatus = {
  "Exito": "text-green-500",
  "En espera" : "text-yellow-500",
  "Perdido": "text-red-500",
  "Anulada" : "text-black"
}

export const BackgroundColorQuotesStatus = {
  "Exito": "bg-green-200",
  "En espera" : "bg-yellow-200",
  "Perdido": "bg-red-200",
  "Anulada" : "bg-gray-200"
}

export const BackgroundColorQuotesStatusHex = {
  "Exito": "#bbf7d0",     // bg-green-200
  "En espera": "#fef08a", // bg-yellow-200
  "Perdido": "#fecaca",   // bg-red-200
  "Anulada": "#e5e7eb"    // bg-gray-200
};

export const ClientTypeColor = {
  "No definido": "text-gray-400",
  "Amable": "text-green-500",
  "Normal": "text-blue-400",
  "Problematico": "text-red-400"
}

export const vipClientColor = {
  "No": "text-red-500",
  "Si": "text-yellow-500"
}

export const prioridadesWebsColor = {
  "Va a comprar ADS": "text-orange-400",
  "VIP": "text-yellow-300",
  "Pago todo el servicio": "text-blue-700",
  "Esta a un 80 y tengo todo terminado en 1 dia o menos": "text-red-500",
  "Reciente y envio todo": "text-green-400",
  "Pago por extra pero tiene poco tiempo": "text-purple-700",
  "Pago por extra pero tiene mucho tiempo": "text-blue-500",
  "Envio toda la info pero tardo": "text-blue-900",
  "Esta a un 30 y tengo todo para terminarlo en 2 dias o menos": "text-purple-500",
  "Recién se tuvo la reunion pero no envía la informacion": "text-gray-500",
  "Sin definir": "text-black"
}


export const statusColorMap = {
  "Terminado con exito": "text-green-500",
  "Por comenzar": "text-yellow-300",
  "Cotizando nuevas funciones": "text-orange-400",
  "Falta pagar": "text-red-500",
  "En proceso": "text-blue-500",
  "Abandonado": "text-black",
  "Congelado": "text-sky-300"
}

export const formMapColor = {
  "Respondido": "text-green-500",
  "No respondido": "text-red-500",
  "No asignado": "text-gray-500"
}

export const facturacionMapColor = {
  "Deuda": "text-red-500",
  "Pagado": "text-green-500",
}

export const infoEnviadaMapColor = {
  "No envió nada": "text-red-500",
  "Envió poco": "text-yellow-400",
  "Envió todo": "text-green-500",
  "Por confirmar": "text-gray-500"
}

export const delayResponsibleMapColor = {
  "Por definir": "text-gray-500",
  "Cliente": "text-blue-500",
  "Agencia": "text-red-500",
  "No aplica": "text-gray-500"
}

export const capacitacionHechaMapColor = {
  "No": "text-red-500",
  "Si": "text-green-500"
}

export const taskStatusColorMap = {
  "Pendiente": "text-yellow-500",
  "En proceso": "text-blue-500",
  "Finalizado": "text-green-500",
  "Declinado": "text-red-500",
  "Con retraso": "text-purple-500",
  "Incumplido": "text-red-500",
  "Eliminado": "text-black"
}